import { render, staticRenderFns } from "./Set_order_modal.vue?vue&type=template&id=ca47eb24&scoped=true&lang=pug&"
import script from "./Set_order_modal.vue?vue&type=script&lang=js&"
export * from "./Set_order_modal.vue?vue&type=script&lang=js&"
import style0 from "./Set_order_modal.vue?vue&type=style&index=0&id=ca47eb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca47eb24",
  null
  
)

export default component.exports